import { render, staticRenderFns } from "./userInfoDetail.vue?vue&type=template&id=b8d2b792&scoped=true&"
import script from "./userInfoDetail.vue?vue&type=script&lang=js&"
export * from "./userInfoDetail.vue?vue&type=script&lang=js&"
import style0 from "./userInfoDetail.vue?vue&type=style&index=0&id=b8d2b792&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d2b792",
  null
  
)

export default component.exports